import { MenuItem, Select } from "@mui/material";

const FilterStatus = ({ setFilters, filters }) => {
  const handleSelect = (event) => {
    setFilters((prev) => ({ ...prev, status: Number(event.target.value) }));
  };

  return (
    <Select size="small" value={filters.status} onChange={handleSelect}>
      <MenuItem value={4}>All Status</MenuItem> {/* Represent "all" as 4 */}
      <MenuItem value={0}>Pending</MenuItem>
      <MenuItem value={1}>Running</MenuItem>
      <MenuItem value={2}>Completed</MenuItem>
      <MenuItem value={3}>Sold</MenuItem>
    </Select>
  );
};

export default FilterStatus;
